import { Component, OnInit, OnDestroy } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Subject, takeUntil, Subscription, combineLatest, startWith, tap } from 'rxjs';
import { SelectedItem } from '@/core/models/selected-item.interface';
import { UserService } from '@/core/services/open-api/user.service';
import { Account } from '@/core/models/account';
@Component({
    selector: 'app-group-dashboard',
    templateUrl: './team-dashboard.component.html',
    // styleUrls: ['./team-dashboard.component.scss'],
    standalone: false,
})
export class TeamDashboardComponent implements OnInit, OnDestroy {
    private destroy$ = new Subject<void>();
    stateOptions!: SelectedItem[];
    selectedView!: string;
    isSingleUserAcc: boolean = false;
    componentInitialized: boolean = false;
    subscriptions = new Subscription();

    constructor(
        private translate: TranslateService,
        private readonly userService: UserService,
    ) {}

    ngOnInit(): void {
        combineLatest([
            this.translate.onLangChange.pipe(
                startWith(null),
                tap(() => this.initStateOptions()),
            ),
            this.userService.account$.pipe(
                tap((account: Account) => {
                    this.isSingleUserAcc = account.isSingleUserAccount();
                }),
            ),
        ])
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.componentInitialized = true;
            });
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    initStateOptions(): void {
        this.translate
            .get(['member_option', 'group_option'])
            .pipe(takeUntil(this.destroy$))
            .subscribe((res) => {
                this.stateOptions = [
                    { label: res['member_option'], value: 'members' },
                    { label: res['group_option'], value: 'groups' },
                ];

                this.selectedView = this.stateOptions[0].value;
            });
    }

    toggleState(state: string): void {
        this.selectedView = state;
    }

    handleUpdate(): void {
        this.isSingleUserAcc = false;
    }
}
